module.exports = __webpack_public_path__ + "img/prize-05.e506e5e4.jpg";